import { useEffect } from 'react';

import { getLogger, tracker } from 'app-components/utils/core';

import { appSetOnlineStatus } from 'data/app/actions';
import { useAppDispatch } from 'hooks/redux';

const log = getLogger('startup/useOnlineStatusSync');

/** Mirrors the browser's online status into the store, now and on every online/offline event. */
export function useOnlineStatusSync(): void {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const handleNetworkChange = (event?: Event) => {
      const online = navigator.onLine;
      const state = online ? 'online' : 'offline';
      const trigger = event ? 'event' : 'navigator';
      log.info(`Application is ${state} (${trigger})`, online, event?.type);
      dispatch(appSetOnlineStatus(online));
      tracker.track(tracker.events.connection, { state, trigger, navigator: online, event: event?.type });
    };

    window.addEventListener('online', handleNetworkChange);
    window.addEventListener('offline', handleNetworkChange);
    handleNetworkChange();
    return () => {
      window.removeEventListener('online', handleNetworkChange);
      window.removeEventListener('offline', handleNetworkChange);
    };
  }, [dispatch]);
}
